(function () {
  const defaultCurrency = "EUR";
  let selectedCurrency = localStorage.getItem("selectedCurrency") || defaultCurrency;
  let exchangeRates = {};
  let geoCurrency = defaultCurrency;

  const currencySymbols = {
    AED: "د.إ", AFN: "؋", ALL: "L", AMD: "֏", ANG: "ƒ", AOA: "Kz", ARS: "$", AUD: "A$", AWG: "ƒ",
    AZN: "₼", BAM: "KM", BBD: "$", BDT: "৳", BGN: "лв", BHD: ".د.ب", BIF: "FBu", BMD: "$", BND: "$",
    BOB: "Bs", BRL: "R$", BSD: "$", BTN: "Nu.", BWP: "P", BYN: "Br", BZD: "$", CAD: "C$", CDF: "FC",
    CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "$", CVE: "$", CZK: "Kč", DJF: "Fdj",
    DKK: "kr", DOP: "$", DZD: "دج", EGP: "£", ERN: "Nfk", ETB: "Br", EUR: "€", FJD: "$", FKP: "£",
    FOK: "kr", GBP: "£", GEL: "₾", GGP: "£", GHS: "₵", GIP: "£", GMD: "D", GNF: "FG", GTQ: "Q",
    GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HTG: "G", HUF: "Ft", IDR: "Rp", ILS: "₪", IMP: "£",
    INR: "₹", IQD: "ع.د", IRR: "﷼", ISK: "kr", JEP: "£", JMD: "$", JOD: "د.ا", JPY: "¥", KES: "Sh",
    KGS: "с", KHR: "៛", KID: "$", KMF: "CF", KRW: "₩", KWD: "د.ك", KYD: "$", KZT: "₸", LAK: "₭",
    LBP: "ل.ل", LKR: "Rs", LRD: "$", LSL: "L", LYD: "ل.د", MAD: "د.م.", MDL: "L", MGA: "Ar", MKD: "ден",
    MMK: "K", MNT: "₮", MOP: "P", MRU: "UM", MUR: "₨", MVR: "Rf", MWK: "MK", MXN: "$", MYR: "RM",
    MZN: "MT", NAD: "$", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", OMR: "ر.ع.", PAB: "B/.",
    PEN: "S/", PGK: "K", PHP: "₱", PKR: "₨", PLN: "zł", PYG: "₲", QAR: "ر.ق", RON: "lei", RSD: "дин.",
    RUB: "₽", RWF: "FRw", SAR: "ر.س", SBD: "$", SCR: "₨", SDG: "ج.س.", SEK: "kr", SGD: "$", SHP: "£",
    SLL: "Le", SOS: "Sh", SRD: "$", SSP: "£", STN: "Db", SYP: "£", SZL: "L", THB: "฿", TJS: "ЅМ",
    TMT: "T", TND: "د.ت", TOP: "T$", TRY: "₺", TTD: "$", TVD: "$", TWD: "NT$", TZS: "Sh", UAH: "₴",
    UGX: "Sh", USD: "$", UYU: "$", UZS: "so'm", VES: "Bs.", VND: "₫", VUV: "Vt", WST: "T", XAF: "FCFA",
    XCD: "$", XOF: "CFA", XPF: "₣", YER: "﷼", ZAR: "R", ZMW: "ZK", ZWL: "$"
  };

  function fetchRates() {
    fetch("https://www.floatrates.com/daily/eur.json")
      .then(res => res.json())
      .then(data => {
        exchangeRates = {};
        for (const code in data) {
          exchangeRates[code.toUpperCase()] = data[code].rate;
        }
        exchangeRates[defaultCurrency] = 1;
        convertPrices();
      })
      .catch(err => console.error("Exchange rate error:", err));
  }

  function convertPrices() {
    const currency = selectedCurrency.toUpperCase();
    const symbol = currencySymbols[currency] || currency;
    document.querySelectorAll("[data-price]").forEach(el => {
      const base = parseFloat(el.getAttribute("data-price"));
      if (!isNaN(base) && exchangeRates[currency]) {
        const newPrice = (base * exchangeRates[currency]).toFixed(2);
        el.innerText = `${newPrice} ${symbol}`;
      }
    });
  }

  function initDropdown(dropdown, whichCurrency) {
    // whichCurrency = geoCurrency or defaultCurrency
    if (dropdown.dataset.currencyInitialized) return;
    dropdown.dataset.currencyInitialized = "1";
    const supported = [defaultCurrency, "USD", (whichCurrency || defaultCurrency).toUpperCase()];
    const unique = [...new Set(supported)];
    dropdown.innerHTML = "";
    unique.forEach(code => {
      const option = document.createElement("option");
      option.value = code;
      option.textContent = code;
      dropdown.appendChild(option);
    });

    const saved = localStorage.getItem("selectedCurrency");
    selectedCurrency = saved && unique.includes(saved) ? saved : defaultCurrency;
    dropdown.value = selectedCurrency;

    dropdown.addEventListener("change", function () {
      selectedCurrency = this.value;
      localStorage.setItem("selectedCurrency", selectedCurrency);
      convertPrices();
      // Sync all dropdowns on change
      document.querySelectorAll(".currency-select").forEach(d => {
        if (d !== this) d.value = selectedCurrency;
      });
    });
  }

  // 1. Immediately initialize all existing dropdowns with default/EUR+USD
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".currency-select").forEach(dropdown => {
      initDropdown(dropdown, defaultCurrency);
    });
    fetchRates();
  });

  // 2. When geolocation returns, re-initialize all dropdowns with geoCurrency
  fetch("https://ipapi.co/json")
    .then(res => res.json())
    .then(data => {
      geoCurrency = data.currency || defaultCurrency;
      document.querySelectorAll(".currency-select").forEach(dropdown => {
        // Remove initialization flag to force re-init!
        dropdown.removeAttribute('data-currency-initialized');
        initDropdown(dropdown, geoCurrency);
      });
    })
    .catch(() => {
      // On failure, no action (already initialized with default)
    });

  // 3. MutationObserver for dynamically added dropdowns
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(".currency-select")) {
            // If geoCurrency changed, always re-initialize with geoCurrency
            node.removeAttribute('data-currency-initialized');
            initDropdown(node, geoCurrency);
          }
          node.querySelectorAll && node.querySelectorAll(".currency-select").forEach(sel => {
            sel.removeAttribute('data-currency-initialized');
            initDropdown(sel, geoCurrency);
          });
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
